import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/withdraw/withdraw_bg.png'


const _hoisted_1 = { class: "withdraw_container" }
const _hoisted_2 = { class: "channel_text" }
const _hoisted_3 = { class: "channel_list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "balance_container" }
const _hoisted_7 = { class: "balance_text" }
const _hoisted_8 = { class: "balance_value" }
const _hoisted_9 = { class: "sub_container" }
const _hoisted_10 = { class: "input_text" }
const _hoisted_11 = {
  key: 0,
  class: "withdrawNotice"
}
const _hoisted_12 = { class: "btn_container" }
const _hoisted_13 = {
  key: 2,
  class: "descriptionContainer"
}
const _hoisted_14 = { class: "noticeText" }

import CustomHeader from '../components/common/customHeader.vue';
import { ref } from 'vue'
import InputField from '../withdraw/components/inputField.vue';
import { PayChannel } from '@/types/common';
import WithdrawPopup from '../../themeOne/withdraw/withdrawPopup.vue';
import { formatCurrency } from '@/utils/commonFunction';
import { WithdrawViewData } from '@/view/withdraw/supportScript';
import MainButton from '../components/common/mainButton.vue';
import CryptoWithdraw from './cryptoWithdraw.vue';
import { useRoute, useRouter } from 'vue-router';
import { useUserStore } from '@/stores/user';


export default /*@__PURE__*/_defineComponent({
  __name: 'withdrawView',
  props: {
    dataSet: {}
  },
  emits: ['confirmWithdraw', 'selectChannel', 'inputValueChange'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const router = useRouter()
const userStore = useUserStore()
const props = __props

const selectChannel = (item: PayChannel) => {
    emits('selectChannel', item)
}

const inputValueChange = (value: any) => {
    emits('inputValueChange', value)
}

const confirmWithdraw = () => {
    emits('confirmWithdraw')
}
const backNavigate = () => {
    router.go(-1)
}
const goToFund = () => {
    router.replace({ path: '/fundsHistory', query: { tabIndex: 1 } })
}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('common.sake'),
      "show-fund": true,
      onGoToFund: goToFund,
      "is-popup-close-back-icon": true,
      onClosePopup: backNavigate
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "top-banner" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: ""
        })
      ], -1)),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('common.paymentChannel')) + "：", 1),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet?.channelList, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["channel_card", _ctx.dataSet?.activeChannel.id == item.id ? 'active_channel' : '']),
            key: item.name,
            onClick: ($event: any) => (selectChannel(item))
          }, _toDisplayString(item.name), 11, _hoisted_4))
        }), 128))
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "line" }, null, -1)),
      (_ctx.dataSet.activeChannel.channelType == '6')
        ? (_openBlock(), _createBlock(CryptoWithdraw, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('withdraw.myBalance')) + ":", 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(formatCurrency)(_ctx.dataSet?.balanceAmount)), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('withdraw.withdrawalAmount')), 1),
              _createVNode(InputField, {
                modelValue: _ctx.dataSet?.selectedAmount,
                labelText: _ctx.$t('withdraw.valueLabel'),
                onValueChanged: inputValueChange
              }, null, 8, ["modelValue", "labelText"])
            ]),
            (_ctx.dataSet?.remainingTurnOver > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_van_icon, {
                    name: "info-o",
                    color: "#ffffff87",
                    size: "14"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('withdraw.betMoreNotice', { value: _unref(formatCurrency)(_ctx.dataSet?.remainingTurnOver) })), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(MainButton, {
                title: _ctx.$t('common.sake'),
                activeStatus: _ctx.dataSet?.activeButton,
                onClick: confirmWithdraw
              }, null, 8, ["title", "activeStatus"])
            ])
          ])),
      (_unref(userStore).isEnableWithdrawNotice && _ctx.dataSet?.withdrawControls?.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('common.notice')), 1),
            _createVNode(_component_van_row, { class: "tabelHeader" }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "tabeldata"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('withdraw.rechargeTimes')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "tabeldata"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('withdraw.rechargeAmount')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet?.withdrawControls, (item, index) => {
              return (_openBlock(), _createBlock(_component_van_row, {
                key: index,
                class: _normalizeClass(index % 2 === 0 ? 'row-dark' : 'row-light')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "12",
                    class: "tabeldata"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.rechargeTime) + " X", 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_van_col, {
                    span: "12",
                    class: "tabeldata"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.minAmount), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["class"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})